import EventsHelper from '../../../_helpers/events';

export default class PoolRankingTabs {
  constructor() {
    let _this = this;
    _this.init();
    EventsHelper.OnAjaxModuleLoaded(function () {
      _this.init();
    });
  }

  init() {
    let _this = this;

    $('.vbw-pool-ranking--tables.tabs-nav .tab-item a').click(function (e) { _this.setMode(e) });
    $('.vbw-pools-container--combined .vbw-pool-ranking--tables.tabs-nav .tab-item a').click(function (e) { _this.setGender(e) });


    $('.vbw-pool-ranking--tables.tabs-nav .tab-item a.basic-mode').click();
    $(' .vbw-pool-ranking--tables.tabs-nav .tab-item a.men-mode').click();
  }

  setMode(e) {
    let element = e.currentTarget;
    if (element.classList.contains('basic-mode')) {
      $(element).parents('.vbw-table-container').find('table').addClass('basic');
      $(element).parents('.vbw-table-container').find('table').removeClass('advanced');
      $(element).parents('.vbw-table-container').find('.advanced').addClass('--hide');
      $(element).parents('.vbw-table-container').find('.basic').removeClass('--with-advanced');
    }
    else if (element.classList.contains('advanced-mode')) {
      $(element).parents('.vbw-table-container').find('table').addClass('advanced');
      $(element).parents('.vbw-table-container').find('table').removeClass('basic');
      $(element).parents('.vbw-table-container').find('.advanced').removeClass('--hide');
      $(element).parents('.vbw-table-container').find('.basic').addClass('--with-advanced');
    }
  }

  setGender(e) {
    let element = e.currentTarget;
    if (element.classList.contains('men-mode')) {
      $('[data-gender="men"]').removeClass('hidden');
      $('[data-gender="women"]').addClass('hidden');
    }
    else if (element.classList.contains('women-mode')) {
      $('[data-gender="men"]').addClass('hidden');
      $('[data-gender="women"]').removeClass('hidden');

    }
  }
}
